export default __webpack_public_path__ + "static/media/emptyLink.216b4eb1.svg";